import config from '../../../config/config';
import { PortalType } from '../../../config/enum';
import { detectPortalType } from '../../../contexts/PortalContext/PortalProvider';
import postRequest from '../base/post';
import postStream from '../base/postStream';

const portalType = detectPortalType();

export default {
  /**
   * Super admin auth login function
   * @param {any} data data
   * @returns {any} promise
   */
  login: (data: any = {}): Promise<any> => {
    return postRequest(
      `${config.subscription.authApiUrl}api/tenant-admin/v1/${portalType === PortalType.PARTNER ? 'partner-auth' : 'auth'}/login`,
      data,
    );
  },
  /**
   * Logout the auth function
   * @param {any} data data
   * @returns {any} promise
   */
  logout: (data: any = {}): Promise<any> => {
    return postRequest(`${config.subscription.authApiUrl}api/tenant-admin/v1/auth/logout`, {
      ...data,
    });
  },
  /**
   * Verify reset password OTP API
   * @param {any} data data
   * @returns {any} promise
   */
  resetPasswordOTPVerify: (data: any = {}): Promise<any> => {
    return postRequest(
      `${config.subscription.authApiUrl}api/tenant-admin/v1/auth/forgot-password-otp-verify`,
      data,
    );
  },
  /**
   * Super admin forgot password function
   * @param {any} data data
   * @returns {any} promise
   */
  forgotPassword: (data: any = {}): Promise<any> => {
    return postRequest(
      `${config.subscription.authApiUrl}api/tenant-admin/v1/auth/forgot-password`,
      data,
    );
  },
  /**
   * Self register API
   * @param {any} data data
   * @param {any} handleUploadProgress progress callback
   * @returns {any} promise
   */
  selfRegistration: (data: any, handleUploadProgress: (progress: any) => void): Promise<any> => {
    return postStream(
      `${config.subscription.accountApiUrl}api/partner/v1/user-account/create`,
      data,
      true,
      handleUploadProgress,
    );
  },
  /**
   * Super admin auth login function
   * @param {any} data - Access request data
   * @returns {any} A promise that resolves with access status
   */
  accessFacilityPortal: (data: any = {}): Promise<any> => {
    return postRequest(
      `${config.subscription.authApiUrl}api/cpo/v1/auth/access-facility-portal`,
      data,
    );
  },
};
